import React from 'react'
import {useStore} from '../Store/useStore'

function JournalLink({url, content}) {
    let target = '_self';

    if (url.indexOf('https://') === 0) {
        target = '_blank';
    }

    return (
        <a href={url} target={target}>
            {content}
        </a>
    );
}

const Journal = ({resultItem}) => {
    const translations = useStore((state) => state.translations)

    return (
        <div className="journal-list__item">
            <div className="journal-list__item--content">
                <JournalLink url={resultItem.targetUri} content={<img src={resultItem.imageUri} loading="lazy"/>}/>
                <h4 className="journal-list__item-headline">
                    <JournalLink url={resultItem.targetUri} content={resultItem.title}/>
                </h4>
                <div className="journal-list__item-description">{resultItem.description}</div>
            </div>
            <div className="journal-list__item-actions">
                <div className="journal-list__item-specification">{resultItem.date}</div>
                <JournalLink url={resultItem.targetUri} content={translations.button}/>
            </div>
        </div>
    )
}

export default Journal
